import React, { Component } from "react";
import { connect } from "react-redux";
//Actions
import { impersonateUser } from "../../redux/actions/Account";
import { sendEmailUser, sendEmailUserGroup } from "../../redux/actions/Email";
import { setUserApproval, getUserGroup } from "../../redux/actions/User";

// Components
import { Button } from "../atoms/Button";
import { CourierTable, NonProfitTable } from "../organisms/Table";
import { nonProfitHeaders } from "../../model/Table";

// Constants
import { newStatus } from "../../model/Table";
import i18nstring, { strings } from "../../i18n";

// Themes
import "./PageStyles.scss";
import { Roles } from "../../Shared/Constants/Roles";

class NonProfitReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMoreModalOpen: false,
      selectedUsersPending: [],
      selectedUsersApproved: []
    };
  }

  componentDidMount() {
    if (!this.props.nonProfitsFetched) {
      this.props.attemptGetUsers(Roles.RECIPIENT);
    }

    const selectableUsers = {};
    this.props.nonProfits.forEach(nonProfit => {
      selectableUsers[nonProfit.id] = false;
    });
    this.setState({
      selectedUsersPending: selectableUsers,
      selectedUsersApproved: selectableUsers
    });
  }

  render() {
    const { isMoreModalOpen, selectedUsersPending, selectedUsersApproved } =
      this.state;

    const setMoreModal = () =>
      this.setState({ isMoreModalOpen: !isMoreModalOpen });
    const selectUserPending = selectedUsers =>
      this.setState({ selectedUsersPending: selectedUsers });
    const selectUserApproved = selectedUsers =>
      this.setState({ selectedUsersApproved: selectedUsers });
    const toggleSelectedUserPending = userId => {
      const newThings = { ...selectedUsersPending };
      if (userId === newStatus.APPROVED || userId === newStatus.PENDING) {
        if (selectedUsersPending[userId]) {
          Object.keys(selectedUsersPending).map(
            user => (newThings[user] = false)
          );
          newThings[userId] = false;
        } else {
          Object.keys(selectedUsersPending).map(
            user => (newThings[user] = true)
          );
          newThings[userId] = true;
        }
      }
      newThings[userId] = !selectedUsersPending[userId];
      selectUserPending(newThings);
    };

    const toggleSelectedUserApproved = userId => {
      const newThings = { ...selectedUsersApproved };
      if (userId === newStatus.APPROVED || userId === newStatus.PENDING) {
        if (selectedUsersApproved[userId]) {
          Object.keys(selectedUsersApproved).map(
            user => (newThings[user] = false)
          );
          newThings[userId] = false;
        } else {
          Object.keys(selectedUsersApproved).map(
            user => (newThings[user] = true)
          );
          newThings[userId] = true;
        }
      }
      newThings[userId] = !selectedUsersApproved[userId];
      selectUserApproved(newThings);
    };
    const toggleMore = () => setMoreModal(!isMoreModalOpen);
    const sendEmail = (userId, body, subject) =>
      this.props.attemptSendEmail([userId], body, subject);
    const sendEmailMultiple = (userIds, body, subject) =>
      this.props.attemptSendEmail(userIds, body, subject);
    const sendEmailToGroup = (body, subject) =>
      this.props.attemptSendEmailToGroup([Roles.RECIPIENT], body, subject);
    const changeApproval = (newStatus, userId) =>
      this.props.attemptApproveUser(newStatus, userId);
    const impersonateUser = userId => {
      this.props.attemptImpersonateUser(userId);
    };
    const refreshUsers = () => {
      this.setState({ refreshed: false });
      this.props.attemptGetUsers(Roles.RECIPIENT);
    };

    return (
      <div className="main_container_section">
        <div className="refresh_container">
          <Button onClick={refreshUsers}>{i18nstring(strings.REFRESH)}</Button>
        </div>
        <div className="main_container_table">
          <div className="table_title">
            {i18nstring(strings.PENDING_APPROVALS)}
          </div>
          <CourierTable
            approvalStatus={newStatus.PENDING}
            headers={nonProfitHeaders}
            changeApproval={changeApproval}
            users={this.props.nonProfits.filter(
              user => user.approvalStatus === newStatus.PENDING
            )}
            toggleMore={toggleMore}
            sendEmail={sendEmail}
            sendEmailMultiple={sendEmailMultiple}
            sendEmailToGroup={sendEmailToGroup}
            userGroup={Roles.COURIER}
            selectedUsers={selectedUsersPending}
            selectUser={toggleSelectedUserPending}
          />
        </div>
        <div className="main_container_table">
          <div className="table_title">
            {i18nstring(strings.APPROVED_NONPROFITS)}
          </div>
          <NonProfitTable
            approvalStatus={newStatus.APPROVED}
            headers={nonProfitHeaders}
            impersonate={impersonateUser}
            changeApproval={changeApproval}
            users={this.props.nonProfits.filter(
              user => user.approvalStatus === newStatus.APPROVED
            )}
            toggleMore={toggleMore}
            sendEmail={sendEmail}
            sendEmailMultiple={sendEmailMultiple}
            sendEmailToGroup={sendEmailToGroup}
            userGroup={Roles.RECIPIENT}
            selectedUsers={selectedUsersApproved}
            selectUser={toggleSelectedUserApproved}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  nonProfits: state.user.nonProfits,
  nonProfitsFetched: state.user.nonProfitsFetched
});

const mapDispatchToProps = dispatch => {
  return {
    attemptApproveUser: (newStatus, userId) =>
      dispatch(setUserApproval(newStatus, Roles.RECIPIENT, userId)),
    attemptGetUsers: userGroup => dispatch(getUserGroup(userGroup)),
    attemptSendEmail: (userIds, body, subject) =>
      dispatch(sendEmailUser(userIds, body, subject)),
    attemptSendEmailToGroup: (userGroup, body, subject) =>
      dispatch(sendEmailUserGroup(userGroup, body, subject)),
    attemptImpersonateUser: impersonateId =>
      dispatch(impersonateUser(impersonateId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NonProfitReview);
